import React, { useEffect, useState } from "react";
import { Polyline, useMap } from "react-leaflet";
import { apiCallGeneric } from "../../services/api-service";
import L from "leaflet";

/**
 * RoadRoute Component
 * Renders a road route between two points on a Leaflet map using OSRM data.
 */
const RoadRoute = ({ from, to }) => {
  const [routePositions, setRoutePositions] = useState([]);
  const map = useMap();

  useEffect(() => {
    if (!from || !to) return;

    const fetchRoute = async () => {
      try {
        // OSRM expects lon,lat
        // Request alternatives to find the shortest path (less km)
        const url = `https://router.project-osrm.org/route/v1/driving/${from[1]},${from[0]};${to[1]},${to[0]}?overview=full&geometries=geojson&alternatives=true`;
        const response = await apiCallGeneric("GET", url);

        if (response?.data?.routes && response.data.routes.length > 0) {
          // Find the route with the shortest distance
          const bestRoute = response.data.routes.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));

          const coordinates = bestRoute.geometry.coordinates;
          // GeoJSON is [lon, lat], Leaflet requires [lat, lon]
          const latLngs = coordinates.map((coord) => [coord[1], coord[0]]);
          setRoutePositions(latLngs);

          // Fit map bounds to the newly fetched route
          if (latLngs.length > 0) {
            const bounds = L.latLngBounds(latLngs);
            map.fitBounds(bounds, { padding: [50, 50] });
          }
        }
      } catch (error) {
        // Error logged internally by apiCallGeneric/service
      }
    };

    fetchRoute();
  }, [from, to, map]);

  return routePositions.length > 0 ? (
    <Polyline
      positions={routePositions}
      color="#3469E7"
      weight={5}
      opacity={0.8}
      lineJoin="round"
    />
  ) : null;
};

export default RoadRoute;
